//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/TaggedObject.js";
let d=[[[0,"Layer",1,0],[0,"LayerOption",1,0]],[[["layerOption"],"IsValidLayerOption",{R_:{valid:''}},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Display.LayerSettingsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.LayerSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.LayerSettingsBuilder.LayerOptionType = Object.freeze({
    "Maintain" : "Maintain", "Original" : "Original", "Work" : "Work", "UserDefined" : "UserDefined"});

export default SPLM;